(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
if (!customElements.get('clasp-cart-recommendation')) {
  class ClaspCartRecommendation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.revealImages(this.closest('cart-drawer'));
      this.config = JSON.parse(this.querySelector('[data-compact-cart-config]').textContent);
      this.config.root = this.config.root.replace(/\/?$/, '/');
      this.form = this.querySelector('form');
      this.button = this.form.querySelector('button');
      this.errorNode = this.querySelector('[role="alert"]');
      this.refreshLink = this.querySelector('.compact-cart-recommendation-reload');
      this.form.addEventListener('submit', event => this.add(event));
    }
    revealImages(scope) {
      scope?.querySelectorAll('img[loading="lazy"]:not(.loaded)').forEach(image => {
        if (image.complete && image.naturalWidth) image.classList.add('loaded');
        else image.addEventListener('load', () => image.classList.add('loaded'), {once:true});
      });
    }
    async request(path, body) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(path, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: {Accept: 'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
          ...(body ? {body: JSON.stringify(body)} : {})
        });
        const data = await response.json();
        if (!response.ok) {
          const error = new Error(data.description || data.message || this.config.error);
          error.status = response.status;
          throw error;
        }
        return data;
      } catch (error) {
        if (controller.signal.aborted) throw new Error(this.config.error);
        throw error;
      } finally {
        clearTimeout(timeout);
      }
    }
    hasCompact(cart) {
      return cart.items.some(item => Number(item.product_id) === this.config.productId);
    }
    async refresh(html) {
      if (!html) {
        const url = new URL(this.config.cartUrl, window.location.origin);
        url.searchParams.set('sections', 'cart');
        const sections = await this.request(url.pathname + url.search);
        html = sections.cart;
      }
      if (!html) throw new Error(this.config.error);
      const drawer = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
      const oldDrawer = this.closest('cart-drawer');
      if (!drawer || !oldDrawer) throw new Error(this.config.error);
      oldDrawer.replaceWith(drawer);
      this.revealImages(drawer);
      return drawer;
    }
    async add(event) {
      event.preventDefault();
      const root = this.closest('.main-cart');
      if (this.pending || document.body.classList.contains('loading') ||
          root.getAttribute('aria-busy') === 'true' || window.RTHCompactCart?.busy) return;
      this.pending = true;
      const controls = Array.from(root.querySelectorAll('button')).map(button => [button, button.disabled]);
      const label = this.button.innerHTML;
      controls.forEach(([button]) => {button.disabled = true;});
      this.button.textContent = this.config.adding;
      this.errorNode.hidden = true;
      this.refreshLink.hidden = true;
      root.setAttribute('aria-busy', 'true');
      document.body.classList.add('loading');
      let attempted = false;
      let confirmed = false;
      let uncertain = false;
      try {
        const before = await this.request(this.config.root + 'cart.js');
        if (this.hasCompact(before) || before.item_count === 0) {
          await this.refresh();
          return;
        }
        if (window.RTHCompactCart?.problems(before).length) throw new Error(this.config.error);
        attempted = true;
        const added = await this.request(this.config.root + 'cart/add.js', {
          items:[{id:this.config.variantId,quantity:1}],
          sections:['cart'],sections_url:window.location.pathname + window.location.search
        });
        confirmed = true;
        const drawer = await this.refresh(added.sections?.cart);
        const status = root.querySelector('[data-compact-cart-status]');
        if (status) status.textContent = this.config.added;
        const item = drawer.querySelector('[data-variant-id="' + this.config.variantId + '"]');
        const focus = item?.querySelector('.remove-item');
        if (focus) focus.focus({preventScroll:true});
      } catch (error) {
        if (attempted && !confirmed && !error.status) {
          try {
            const cart = await this.request(this.config.root + 'cart.js');
            if (this.hasCompact(cart)) {
              confirmed = true;
              await this.refresh();
              const status = root.querySelector('[data-compact-cart-status]');
              if (status) status.textContent = this.config.added;
              return;
            }
          } catch {uncertain = true;}
        }
        if (confirmed) uncertain = true;
        this.errorNode.textContent = uncertain ? this.config.uncertain : error.message || this.config.error;
        this.errorNode.hidden = false;
        this.refreshLink.hidden = !uncertain;
      } finally {
        root.setAttribute('aria-busy', 'false');
        document.body.classList.remove('loading');
        controls.forEach(([button, disabled]) => {if (button.isConnected) button.disabled = disabled;});
        if (this.isConnected) {
          this.button.innerHTML = label;
          this.button.disabled = uncertain;
        }
        this.pending = uncertain;
      }
    }
  }
  customElements.define('clasp-cart-recommendation', ClaspCartRecommendation);
}

  } catch(e) { console.error(e); }
})();
})();
